
class TimeTracking{
    constructor() {
        this.values = {};
        this.timeForDuration = {};
    }

    addTracker ( model, url){
        this.values[url] = {
            model,
            duration: null
        };
        this.timeForDuration[url] = {start:  window.performance.now(), end: 0};
    }

    trackingEnded (key){
        this.timeForDuration[key].end = window.performance.now();
        this.values[key].duration = this.timeForDuration[key].end - this.timeForDuration[key].start;
    }

    getAllTime (){
        let values = Object.values(this.values);

        return values.reduce((previous, item) => {
            return previous + item.duration;
        }, 0);
    }

    getTimeByModel (){
        let values = Object.values(this.values);
        let models = [... new Set(values.map((val) => val.model))];
        let valuesByModel = {};

        for(let model of models){
            valuesByModel[model] = values.reduce((total, item) => {
                if(model !== item.model){
                    return total;
                }
                return total + item.duration;
            }, 0);
        }
        return valuesByModel;
    }
}

export { TimeTracking };



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/components/partials/time-tracking.js
// module id = wLXW
// module chunks = 0